import React from 'react';
const locationHost = window.location.host;
let isFreely = false;
if (locationHost.indexOf('freely') > -1) {
  isFreely = true;
}

const Highlights = ({ highlights, toggleHighlight }) => (
  <div className="tvg-toolbar__highlights">
    {highlights.map((el, i) => (
      <label
        key={i}
        className={el.value ? 'active' : ''}
        htmlFor={`tvg-highligh-${el.name}`}
        style={
          el.value
            ? {
                boxShadow: `0px 0px 12px 4px ${
                  isFreely ? el.freelyColor : el.color
                }`,
              }
            : {}
        }
      >
        <span>
          {el.name}
          <span
            className="border-color"
            style={{ color: isFreely ? el.freelyColor : el.color }}
          />
        </span>
        <input
          type="checkbox"
          id={`tvg-highligh-${el.name}`}
          onClick={() => {
            toggleHighlight(el.name, !el.value);
          }}
        />
      </label>
    ))}
  </div>
);

export default Highlights;
